import axios from "axios";

export const apiClient = axios.create({
    baseURL: "https://api.coinsup.in/api/v1",
    withCredentials: true
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (err) => Promise.reject(err)
);
